import { Table, TableColumnsType } from "antd";
import moment from "moment";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import { getDashboardInquiry } from "../../../api/dashboard.api";
import useAxios from "../../../hooks/useAxios";
import { IDashboardInquiry, IGetDashboardInquiry } from "../../../models/dashboard.model";
import { RootState } from "../../../store/rootReducer";
import ErrorResponse from "../../ErrorResponse";
import Loader from "../../Loader";
import Subtitle from "./Subtitle";
import { useHistory } from "react-router-dom";

const Inquiry = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { currentCampus } = useSelector((state: RootState) => state.auth);
  const { data: res, isLoading, error, execute } = useAxios<IGetDashboardInquiry>();

  useEffect(() => {
    if (currentCampus) {
      execute(getDashboardInquiry(currentCampus));
    }
  }, [currentCampus]);

  const columns: TableColumnsType<IDashboardInquiry> = [
    {
      title: t('class.dashboard.column33'),
      dataIndex: 'title',
      key: 'title',
      align: 'center',
    },
    {
      title: t('class.dashboard.column34'),
      dataIndex: 'regDate',
      key: 'regDate',
      align: 'center',
      render: value => moment(value).format('YYYY.MM.DD'),
    },
  ];

  return (
    <>
      {isLoading && <Loader />}
      <ErrorResponse error={error} />

      <Subtitle
        text={t('class.dashboard.title13')}
        path="/homepage/inquiry"
      />
      <Table
        className='comm-table__area'
        columns={columns}
        dataSource={res?.data}
        onRow={(record) => {
          return {
            onClick: () => {
              history.push(
                `/homepage/inquiry/${record.qnaCode}`,
              );
            },
          };
        }}
        rowClassName="pointer"
      />
    </>
  );
}

export default Inquiry;
